import React from 'react';

import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import Dwg from 'components/SvgComponents/icons/Dwg';
import dropZoneStyle from 'theme/dropzone-theme';
import globalMessages from 'translations/messages/global-messages';

function FileErrorPreviewDwg({ classes, intl }) {
  return (
    <>
      <Dwg className={classes.icon} width="48" height="48" />
      <Typography className={classes.instruction}>
        {intl.formatMessage(globalMessages.uploaded_dwg)}
      </Typography>
      <Typography className={classes.supported}>
        {intl.formatMessage(globalMessages.file_not_displayed_on_web)}
      </Typography>
    </>
  );
}

FileErrorPreviewDwg.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};
export default compose(withStyles(dropZoneStyle), injectIntl)(FileErrorPreviewDwg);
